// extracted by mini-css-extract-plugin
module.exports = {"SearchDropdownRegion":"SearchDropdownRegion_SearchDropdownRegion__rvC6_"};